<template><div><h1 id="etikettenformate" tabindex="-1"><a class="header-anchor" href="#etikettenformate"><span>Etikettenformate</span></a></h1>
<p>Etikettenformate — Definiert Daten und Layout für Etiketten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die im System für den Benutzer verfügbaren Etikettenformate.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Etikettenformate</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr</dt>
<dd>Nummer des Etikettenformats, 2-stellig, wird vom System fortlaufend vergeben, kann manuell eingegeben werden</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des Etikettenformats</dd>
<dt>Zusatzdaten</dt>
<dd>Angabe der zusätzlichen Daten, die nebst den Adresszeilen 1-6 ausgedruckt werden sollen. Daten müssen als Feldnamen angegeben, einzelne Felder mit Komma getrennt werden. Maximale Anzahl Zeichen für die Eingabe der Felder: 15. (adrnum und tel sind möglich)</dd>
<dt>Spalten</dt>
<dd>Anzahl Spalten (X-bahnige Etiketten)</dd>
<dt>Breite</dt>
<dd>Anzahl Zeichen, die pro Etikett gedruckt werden können</dd>
<dt>Breite+Abst.</dt>
<dd>Anzahl Zeichen, die einzelne Etiketts auseinanderliegen (= Breite plus Horizontalabstand in Zeichen)</dd>
<dt>Höhe</dt>
<dd>Anzahl Zeilen, die pro Etikett bedruckt werden können</dd>
<dt>Höhe+Abst.</dt>
<dd>Anzahl Zeilen, die einzelne Etiketts auseinanderliegen (= Höhe plus Vertikalabstand in Zeilen)</dd>
<dt>Kreuzen</dt>
<dd>Vorspann, Anzahl Pseudo-Adressen, die als XXXXX dargestellt bzw. ausgedruckt werden zum Einrichten des Druckers.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


